import { IconInfoCircle } from '@tabler/icons-react';
import { useRef, useState } from 'react';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';

function DateFilterInfoPopup() {
    const [show, setShow] = useState(false);
    const target = useRef(null);

    return (
        <>
            <button ref={target} onClick={() => setShow(!show)}><IconInfoCircle className='text-[#aeafaf]' /></button>
            <Overlay target={target.current} show={show} placement="bottom" rootClose rootCloseEvent='mousedown'>
                {(props) => (
                    <Tooltip id="overlay-example" {...props}>
                        The data is arranged here based on clicks.
                    </Tooltip>
                )}
            </Overlay>
        </>
    );
}

export default DateFilterInfoPopup;